import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Toaster } from "sonner";

export function ToasterPortal() {
  const [portalEl, setPortalEl] = useState(null);

  useEffect(() => {
    const el = document.createElement("div");
    el.setAttribute("data-headlessui-portal", "");
    document.body.appendChild(el);
    setPortalEl(el);
    return () => {
      document.body.removeChild(el);
      setPortalEl(null);
    };
  }, []);

  if (!portalEl) {
    return null;
  }

  return createPortal(
    <Toaster
      position="bottom-center"
      offset={{ bottom: "70px" }}
      richColors
      closeButton
      expand
      duration={60000}
    />,
    portalEl,
  );
}
